import {getCustomCategoryGoals, getGoal, getRestaurantGoal} from "@/api/information";

let inflightPromise = null;
let inflightKey = null;

// WTK-564: goal 永远是对象 { 类别: 数字 | null }。null / 缺 key = 未设置；接口没给 goal 时按 {} 处理。
function toGoalMap(value) {
    return value && typeof value === "object" && !Array.isArray(value) ? value : {};
}

// 酒店自己的分类（WTK-988）的目标并进同一份 goal，key 是 custom:<话题 id>，和趋势图下拉的 value2 一样；
// 这个接口失败时只是没有这些目标，标准分类的目标不受影响
function fetchHotelGoal(hotelId) {
    return Promise.all([getGoal({hotelId}), getCustomCategoryGoals({hotelId}).catch(() => null)]).then(([res, custom]) => {
        if (!custom || !custom.goals) return res;
        const goal = {...toGoalMap(res && res.goal)};
        Object.keys(custom.goals).forEach((topicId) => {
            goal[`custom:${topicId}`] = custom.goals[topicId];
        });
        return {...res, goal};
    });
}

function getEntityKey(rootState) {
    const isHotel = rootState.hotel.isHotel;
    const currentHotelId = rootState.hotel.currentHotelId;
    const selectedRestaurantId = rootState.restaurant.selectedRestaurantId;
    if (isHotel) {
        return currentHotelId ? `hotel:${currentHotelId}` : null;
    }
    return selectedRestaurantId ? `restaurant:${selectedRestaurantId}` : null;
}

export default {
    namespaced: true,
    state: {
        goal: {},
        loadedKey: null,
    },
    mutations: {
        SET_GOAL(state, value) {
            state.goal = toGoalMap(value);
        },
        SET_LOADED_KEY(state, key) {
            state.loadedKey = key;
        },
        RESET_GOAL_CACHE(state) {
            state.goal = {};
            state.loadedKey = null;
        },
    },
    actions: {
        update_goal({state, rootState, commit}, {force = false} = {}) {
            const entityKey = getEntityKey(rootState);
            if (!entityKey) {
                return Promise.resolve(null);
            }

            const isCached =
                !force
                && state.loadedKey === entityKey
                && state.goal
                && typeof state.goal === "object";

            if (isCached) {
                return Promise.resolve({goal: state.goal});
            }

            if (!force && inflightPromise && inflightKey === entityKey) {
                return inflightPromise;
            }

            const isHotel = rootState.hotel.isHotel;
            const currentHotelId = rootState.hotel.currentHotelId;
            const selectedRestaurantId = rootState.restaurant.selectedRestaurantId;

            inflightKey = entityKey;
            inflightPromise = (isHotel
                ? fetchHotelGoal(currentHotelId)
                : getRestaurantGoal({restaurantId: selectedRestaurantId}))
                .then((res) => {
                    commit("SET_GOAL", res && res.goal);
                    commit("SET_LOADED_KEY", entityKey);
                    return res;
                })
                .finally(() => {
                    inflightPromise = null;
                    inflightKey = null;
                });

            return inflightPromise;
        },
    },
};
